import { render, staticRenderFns } from "./dashboardStats.vue?vue&type=template&id=64897468&scoped=true"
import script from "./dashboardStats.vue?vue&type=script&lang=js"
export * from "./dashboardStats.vue?vue&type=script&lang=js"
import style0 from "./dashboardStats.vue?vue&type=style&index=0&id=64897468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64897468",
  null
  
)

export default component.exports